<template>
    <b-card
        class="text-center my-2"
        border-variant="primary"
        :bg-variant="getBgVariant()"
        text-variant="white"
    >
        <div slot="header">
            <span class="figure-title">{{ title }}</span>
        </div>
        <p class="card-text figure-value">
            <slot></slot>
        </p>
    </b-card>
    <!-- <b-card
        class="text-center my-2"
        :title="title"
        border-variant="primary"
    >
        <p class="card-text">
            <slot></slot>
        </p>
    </b-card> -->
</template>
<script>
export default {
    props: ['title', 'status'],
    methods: {
        getBgVariant() {
            if(!this.status) return 'dark';

            const statuses = {
                success: 'success',
                normal: 'dark',
                error: 'danger',
            };

            if(!statuses.hasOwnProperty(this.status)) return 'dark';

            return statuses[this.status];

        }
    }
}
</script>
<style scoped>
.figure-value {
    font-size: 2rem;
    font-weight: bold;
}
.figure-title {
    font-size: 1.5rem;
    font-weight: bold;
}
</style>